import { useState, useEffect, useContext, useCallback } from "react";
import { Link } from "react-router-dom";
import MembershipApi from "../../api/MembershipApi";
import MembershipContext from "../../context/MembershipContext";
import RecentContent from "./RecentContent";

const formatMembershipDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}.${m}.${d}`;
};

const WriteMembership = ({ customStyle }) => {
    const { writeMembershipRefreshKey } = useContext(MembershipContext);
    const [membership, setMembership] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadMembership = useCallback(() => {
        setLoading(true);
        MembershipApi.getActiveWriteMembership()
            .then((data) => setMembership(data))
            .catch((err) => {
                console.error("글쓰기 멤버쉽 조회 실패:", err);
                setMembership(null);
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        loadMembership();
    }, [loadMembership, writeMembershipRefreshKey]);

    const hasActiveMembership = !!membership;
    const periodText =
        hasActiveMembership &&
        `${formatMembershipDate(membership.membership_started_at)} ~ ${formatMembershipDate(membership.membership_expire_at)}`;

    return (
        <div className="membership-ticket-widget" style={customStyle}>
            <div className="membership-ticket-widget-head">
                <h3 className="membership-ticket-widget-title">글쓰기 멤버쉽 이용권</h3>
                <Link to="/mypage/order" className="membership-ticket-widget-link">
                    <span>결제내역</span>
                    <i className="icon icon-arrow-right-bold"></i>
                </Link>
            </div>

            <div className="membership-ticket-widget-box">
                {loading ? (
                    <p className="membership-ticket-widget-empty">불러오는 중...</p>
                ) : hasActiveMembership ? (
                    <>
                        <span className="membership-ticket-widget-grade">
                            {membership.membership_name}
                        </span>
                        <p className="membership-ticket-widget-period">{periodText}</p>
                    </>
                ) : (
                    <p className="membership-ticket-widget-empty">
                        사용가능한 이용권이 없습니다
                    </p>
                )}
            </div>

            {!loading && !hasActiveMembership && (
                <Link to="/membership" className="membership-ticket-widget-button">
                    이용권 구매
                </Link>
            )}
        </div>
    );
};

const MembershipAside = () => {
    return (
        <aside className="vh-content-aside">
            <WriteMembership />

            <a href="#/" className="adv-widget" data-ratio="1.7/1"></a>
            <a href="#/" className="adv-widget" data-ratio="1.7/1"></a>

            <RecentContent />

            <a href="#/" className="adv-widget" data-ratio="1.7/1"></a>
            <a href="#/" className="adv-widget" data-ratio="1.7/1"></a>
        </aside>
    );
};

export default MembershipAside;
export { WriteMembership }